
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Menu from "../../components/menu/Menu";
import MenuGeral from "../../components/menu/MenuGeral";

import Loader from "../../utils/Loader";

import { getFaturacaoDia, getCaixaDia, getCaixaMensal, getCaixaAnual } from "../../services/caixaService";
import { getModalidadesPagamento, getSaidasModalidadesPagamento } from "../../services/caixaService"; //2025-08-20

import Grafico from "../../components/graficos/Grafico"; //2025-08-20

function Financeiro() {
  const navigate = useNavigate();

  let decoded = null;
  const isAuth = localStorage.getItem("token") !== null;
  if (isAuth) decoded = jwtDecode(localStorage.getItem("token"));

  const [refresh, setRefresh] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingCaixaAnual, setIsLoadingCaixaAnual] = useState(true);

  const [valor_total_ano_corrente, setValor_total_ano_corrente] = useState(0);
  const [valor_total_ano_anterior, setValor_total_ano_anterior] = useState(0);

  const [valor_receita_mes_atual, setValor_receita_mes_atual] = useState(0);
  const [valor_saidas_mes_atual, setValor_saidas_mes_atual] = useState(0);

  const [infoGraficoCaixaAnual, setinfoGraficoCaixaAnual] = useState({
    options: {
      chart: {
        id: "apexchart-caixaAnual",
        height: "auto",
      },
      xaxis: {
        categories: [],
      },
      yaxis : {
        labels : {
          show : true,
          formatter: (value) => {
            if (value % 1000 === 0 && value !== 0) return value / 1000 + 'K';
            else return value;
          } 
        }
      },
      dataLabels : {
        enabled : false
      },
      colors: ["#D2D6D6", "#FEB019"]
    },
    series: [
      {
        name : "Ano anterior",
        type : "line",
        data : [],
      },
      {
        name : "Ano corrente",
        type : "line",
        data : [],
      }
    ],
  });

  const [infoGraficoModalidadesReceitasDia, setinfoGraficoModalidadesReceitasDia] = useState({
    options: {
      chart: {
        id: "receitas-modalidades-dia",
        height: "auto",
      },
      labels: [],
    },
    series: [],
  });

  const [infoGraficoModalidadesSaidasDia, setinfoGraficoModalidadesSaidasDia] = useState({
    options: {
      chart: {
        id: "saidas-modalidades-dia",
        height: "auto",
      },
      labels: [],
   },
    series: [],
  });


  const [infoGraficoModalidadesReceitas, setinfoGraficoModalidadesReceitas] = useState({
    options: {
      chart: {
        id: "receitas-modalidades",
        height: "auto",
      },
      labels: [],
   },
    series: [],
  });

  const [infoGraficoModalidadesSaidas, setinfoGraficoModalidadesSaidas] = useState({
    options: {
      chart: {
        id: "saidas-modalidades",
        height: "auto",
      },
      labels: [],
   },
    series: [],
  });

  const [caixa, setCaixa] = useState([]);
  const [error, setError] = useState("");

  const [caixaDia, setCaixaDia] = useState(0);
  const [caixaDiaEntradas, setCaixaDiaEntradas] = useState(0);
  const [caixaDiaSaidas, setCaixaDiaSaidas] = useState(0);

  const [faturacaoDia, setFaturacaoDia] = useState(0);
  const [faturacaoDiaDebito, setFaturacaoDiaDebito] = useState(0);
  const [faturacaoDiaCredito, setFaturacaoDiaCredito] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("token");

    setIsLoading(true);

    //2025-09-20
    getCaixaDia(token)
      .then((response) => {
       
        //console.log("getCaixaDia response: ", response);

        let labels_entrada = [];       
        let labels_saida = [];
        
        let valores_entrada = [];
        let valores_saida = [];

        const movimentos_entrada = response.filter(m => m.movimento === "entrada");
        const movimentos_saida = response.filter(m => m.movimento === "saida");

        movimentos_entrada.forEach((i, index) => labels_entrada.push( i.modalidade.substring(0, 3).toUpperCase() ));
        movimentos_saida.forEach((i, index) => labels_saida.push(i.modalidade.substring(0, 3).toUpperCase() ));

        movimentos_entrada.forEach((i, index) => valores_entrada.push(parseFloat(i.valor.replace(",",""))));
        movimentos_saida.forEach((i, index) => valores_saida.push(Math.abs(parseFloat(i.valor.replace(",","")))));


        //console.log("labels_entrada: ", labels_entrada);
        //console.log("labels_saida: ", labels_saida);
        //console.log("valores_entrada: ", valores_entrada);
        //console.log("valores_saida: ", valores_saida);

        {/*chart: {...infoGraficoModalidadesReceitasDia.options.chart},*/}

        setinfoGraficoModalidadesReceitasDia({
          ...infoGraficoModalidadesReceitasDia,
          options: {
            ...infoGraficoModalidadesReceitasDia.options,
            labels: labels_entrada,
          },
          series: valores_entrada,
        });

        {/*chart: {...infoGraficoModalidadesSaidasDia.options.chart},*/}

        setinfoGraficoModalidadesSaidasDia({
          ...infoGraficoModalidadesSaidasDia,
          options: {
            ...infoGraficoModalidadesSaidasDia.options,
            labels: labels_saida,
          },
          series: valores_saida,
        });


        //setMovimentosEntrada(movimentos_entrada);
        //setMovimentosSaida(movimentos_saida);

        let caixa_dia = 0;
        let caixa_dia_entradas = 0;
        let caixa_dia_saidas = 0;

        for ( let i = 0; i <= response.length - 1; i++) {
          caixa_dia = caixa_dia + parseFloat(response[i].valor.replace(",",""));
        }
        setCaixaDia(caixa_dia);

        for ( let i = 0; i <= movimentos_entrada.length - 1; i++) {
          caixa_dia_entradas = caixa_dia_entradas + parseFloat(movimentos_entrada[i].valor.replace(",",""));
        }
        setCaixaDiaEntradas(caixa_dia_entradas);

        for ( let i = 0; i <= movimentos_saida.length - 1; i++) {
          caixa_dia_saidas = caixa_dia_saidas + Math.abs(parseFloat(movimentos_saida[i].valor.replace(",","")));
        }
        setCaixaDiaSaidas(caixa_dia_saidas);


       })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");

        setError(err.response ? err.response.data : err.message);
        setIsLoading(false);
      });


  }, [refresh]);
  
  useEffect(() => {
    const token = localStorage.getItem("token");

    //2025-09-20
    getFaturacaoDia(token)
      .then((response) => {
       
        //console.log("getFaturacaoDia response: ", response);

        const movimentos_credito = response.filter(m => m.movimento === "credito");
        //console.log("1.1.", movimentos_credito, movimentos_credito.length);
        const movimentos_debito = response.filter(m => m.movimento === "debito");
        //console.log("1.2", movimentos_debito, movimentos_debito.length);

        const movimentos_pendente = response.filter(m => m.movimento === "pendente");

        let faturacao_dia = 0;

        if (movimentos_debito.length) {
          //console.log("debito: ", parseFloat(movimentos_debito[0].valor.replace(",","")));
          faturacao_dia = faturacao_dia + parseFloat(movimentos_debito[0].valor.replace(",",""));
          //console.log("1)", faturacao_dia);
          setFaturacaoDiaDebito(parseFloat(movimentos_debito[0].valor.replace(",","")));
        }

        if (movimentos_credito.length) {
          //console.log("credito: ", parseFloat(movimentos_credito[0].valor.replace(",","")));
          faturacao_dia = faturacao_dia + parseFloat(movimentos_credito[0].valor.replace(",",""));
          //console.log("2)", faturacao_dia);
          setFaturacaoDiaCredito(Math.abs(parseFloat(movimentos_credito[0].valor.replace(",",""))));
        }
        
        setFaturacaoDia(faturacao_dia);


      })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");

        setError(err.response ? err.response.data : err.message);
        setIsLoading(false);
      });


  }, [refresh]);


  useEffect(() => {
    const token = localStorage.getItem("token");

    getCaixaMensal(token)
      .then((response) => {
        //console.log("getCaixaMensal: ", response); //TO DELETE
        setCaixa(response);
       })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");

        setError(err.response ? err.response.data : err.message);
        setIsLoading(false);
      });

  }, [refresh]);


  useEffect(() => {
    const token = localStorage.getItem("token");

    //2025-08-20
    getModalidadesPagamento(token)
      .then(response => {
        //console.log("getModalidadesPagamento", response);
        let labels = [];
        response.forEach((i, index) => labels.push( i.modalidade.substring(0, 3).toUpperCase() ));

        let valores = [];
        let valor_receita_mes_atual_aux = 0;
        response.forEach((i, index) => { valores.push(parseFloat(i.valor)); valor_receita_mes_atual_aux = valor_receita_mes_atual_aux + parseFloat(i.valor)});
        //console.log("Entradas (modalidades de pagamento): ", valor_receita_mes_atual_aux);
        setValor_receita_mes_atual(valor_receita_mes_atual_aux);

        setinfoGraficoModalidadesReceitas({
          ...infoGraficoModalidadesReceitas,
          options: {
            ...infoGraficoModalidadesReceitas.options,
              chart: {...infoGraficoModalidadesReceitas.options.chart},
              labels: labels,
          },
          series: valores,
        });

        // setIsLoading(false);

      })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");

        setError(err.response ? err.response.data : err.message);
        setIsLoading(false);
      })


    //2025-08-20
    getSaidasModalidadesPagamento(token)
      .then(response => {
        //console.log("getSaidasModalidadesPagamento", response);
        let labels = [];
        response.forEach((i, index) => labels.push(i.modalidade.substring(0, 3).toUpperCase() ));

        let valores_saidas = [];
        let valor_saidas_mes_atual_aux = 0;
        response.forEach((i, index) => { valores_saidas.push(parseFloat(Math.abs(i.valor))); valor_saidas_mes_atual_aux = valor_saidas_mes_atual_aux + parseFloat(i.valor)});
        //console.log("AQUI: ", Math.abs(valor_saidas_mes_atual_aux));
        setValor_saidas_mes_atual(Math.abs(valor_saidas_mes_atual_aux));

        setinfoGraficoModalidadesSaidas({
          ...infoGraficoModalidadesSaidas,
          options: {
            ...infoGraficoModalidadesSaidas.options,
              chart: {...infoGraficoModalidadesSaidas.options.chart},
              labels: labels,
          },
          series: valores_saidas,
        });

        setIsLoading(false);

      })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");

        setError(err.response ? err.response.data : err.message);
        setIsLoading(false);
      })


  }, [refresh]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    setIsLoadingCaixaAnual(true);

    //2025-08-20
    getCaixaAnual(token)
      .then(response => {
        //console.log("getCaixaAnual", response);
        const meses_aux = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

        let meses = [];

        //response.forEach((i, index) => meses.push(meses_aux[index]));

        // 2025-10-28 before
        /*
        for ( let i = 0; i <= (response.length / 2) - 1; i++) {
          meses.push(meses_aux[i]);
        }
	*/

	// 2025-10-28
        for ( let i = 0; i <= new Date().getMonth(); i++) {
          meses.push(meses_aux[i]);
        }

        let valores_ano_corrente = [];
        let valor_total_ano_corrente = 0;

        //response.forEach((i, index) => valores_ano_corrente.push(i.faturacao.toFixed(2)));

	// 2025-10-28 before
        /*
        for ( let i = 0; i <= (response.length / 2) - 1; i++) {
          valores_ano_corrente.push(parseFloat(response[i].faturacao));
          valor_total_ano_corrente = valor_total_ano_corrente + parseFloat(response[i].faturacao);
        }
        */

	// 2025-10-28
        for ( let i = 0; i < meses.length; i++) {
	  const v = response.find(v => v.mes === (i + 1) && v.ano === new Date().getFullYear());
          // console.log("X: ", i , v)
          if (v) {
            valores_ano_corrente.push(parseFloat(v.faturacao));
            valor_total_ano_corrente = valor_total_ano_corrente + parseFloat(v.faturacao);
          } else 
              valores_ano_corrente.push(0);
        }
	

        setValor_total_ano_corrente(valor_total_ano_corrente);

        let valores_ano_anterior = [];
        let valor_total_ano_anterior = 0;

	// 2025-10-28 before
        /*
        for ( let i = response.length / 2; i <= response.length - 1 ; i++) {
          valores_ano_anterior.push(parseFloat(response[i].faturacao));
          valor_total_ano_anterior = valor_total_ano_anterior + parseFloat(response[i].faturacao);
        }
        */

	// 2025-10-28
        for ( let i = 0; i < meses.length; i++) {
          
	  const v = response.find(v => v.mes === (i + 1) && v.ano === new Date().getFullYear() - 1);
          // console.log("X-1: ", i , v)
          if (v) {
	    valores_ano_anterior.push(parseFloat(v.faturacao));
            valor_total_ano_anterior = valor_total_ano_anterior + parseFloat(v.faturacao);
          } else
              valores_ano_anterior.push(0);
        }

        setValor_total_ano_anterior(valor_total_ano_anterior);

        setinfoGraficoCaixaAnual({
          //...infoGraficoCaixaAnual,
          options: {
            ...infoGraficoCaixaAnual.options,
            xaxis: {
              ...infoGraficoCaixaAnual.options.xaxis,
              categories: meses,
            }
          },                   
          series : infoGraficoCaixaAnual.series.map( serie => {
            
            if (serie.name === "Ano anterior") {
              return { ...serie, data: valores_ano_anterior};
            } else {
              if (serie.name === "Ano corrente") {
                return { ...serie, data: valores_ano_corrente};
              }
            }
          })
          
        });

        //setIsLoading(false);
        setIsLoadingCaixaAnual(false);

      })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");

        setError(err.response ? err.response.data : err.message);
        setIsLoading(false);
      })

  }, [refresh]);


  const positivo = (
    <svg
      className="icon icon-xs text-success"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );

  const negativo = (
    <svg
      className="icon icon-xs text-danger"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );

  let valor_mes_anterior;

  /* 2025-11-03
  valor_mes_anterior =
    caixa.length > 0 &&
    ((caixa[0].valor / caixa[1].valor - 1) * 100).toFixed(2);
  */


  if (caixa.length > 0) {
    if (caixa[0].valor === 0 && caixa[1].valor === 0) valor_mes_anterior = 0;
    else if (caixa[0].valor === 0 && caixa[1].valor > 0)
      valor_mes_anterior = -100;
    else if (caixa[0].valor > 0 && caixa[1].valor === 0)
      valor_mes_anterior = 100;
    else
      valor_mes_anterior = (
        (caixa[0].valor / caixa[1].valor - 1) *
        100
      ).toFixed(2);
  }

  let valor_mes_homologo;

  /* 2025-11-03
  valor_mes_homologo =
    caixa.length > 0 &&
    ((caixa[0].valor / caixa[2].valor - 1) * 100).toFixed(2);
  */


  if (caixa.length > 0) {
    if (caixa[0].valor === 0 && caixa[2].valor === 0) valor_mes_homologo = 0;
    else if (caixa[0].valor === 0 && caixa[2].valor > 0)
      valor_mes_homologo = -100;
    else if (caixa[0].valor > 0 && caixa[2].valor === 0)
      valor_mes_homologo = 100;
    else
      valor_mes_homologo = (
        (caixa[0].valor / caixa[2].valor - 1) *
        100
      ).toFixed(2);
  }


  let euro = Intl.NumberFormat("en-PT", {
    style: "currency",
    currency: "EUR",
  });

  return (
    <>
      { decoded && decoded.isAdmin ? <Menu /> : <MenuGeral />}
      <main className="content">
        {/*<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
          <div className="d-block mb-1 mb-md-0">
            <h1 className="h4">Faturação</h1>
          </div>
        </div>*/}
        {isLoading ? (
          <div></div>
        ) : (
          <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
              <div className="d-block mb-md-0">
                <h1 className="h4">Faturação</h1>
              </div>
              <div>
                <button
                  onClick={() => {
                    setRefresh((r) => !r);
                  }}
                >
                  Atualizar
                </button>
              </div>
            </div>



          <div className="row">


            <div className="col-12 col-sm-6 col-xl-4 mt-2">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="row d-block d-xl-flex align-items-center">
                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                      <div className="icon-shape icon-shape-secondary rounded me-4 me-sm-0">
                        <svg
                          className="icon"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </div>
                      <div className="d-sm-none">
                        <h4 className="fw-extrabold h5">Caixa do dia</h4>
                        <h3 className="mb-1">
                          {caixa.length > 0 && euro.format(caixaDia)}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-xl-7 px-xl-0">
                      <div className="d-none d-sm-block">
                        <h2 className="h6 text-gray-400 mb-0">Caixa do dia</h2>
                        <h3 className="fw-extrabold mb-2">
                          {caixa.length > 0 && euro.format(caixaDia)}
                        </h3>
                      </div>                      

                      <small className="d-flex align-items-center text-gray-500">
                        &nbsp;
                      </small>

                      <div className="d-flex justify-content-between">
                      <div className="small d-flex mt-1">
                        {/*<h2 className="h6 text-gray-400 mb-0">Entradas:</h2>*/}
                        Entradas:&nbsp;
                        <span className = "text-success fw-bolder">
                          {/*<h6>{" "}{caixa.length > 0 && euro.format(caixaDiaEntradas)}</h6>*/}
                          {caixa.length > 0 && euro.format(caixaDiaEntradas)}
                        </span>
                      </div>
                      <div className="small d-flex mt-1">
                        Saídas:&nbsp;
                        <span className = "text-danger fw-bolder">
                          {caixa.length > 0 && euro.format(caixaDiaSaidas)}
                        </span>
                      </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-xl-4 mt-2">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="row d-block d-xl-flex align-items-center">
                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                      <div className="icon-shape icon-shape-secondary rounded me-4 me-sm-0">
                        <svg
                          className="icon"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </div>
                      <div className="d-sm-none">
                        <h4 className="fw-extrabold h5">Faturação do dia</h4>
                        <h3 className="mb-1">
                          {euro.format(faturacaoDia)}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-xl-7 px-xl-0">
                      <div className="d-none d-sm-block">
                        <h2 className="h6 text-gray-400 mb-0">Faturação do dia</h2>
                        <h3 className="fw-extrabold mb-2">
                          {euro.format(faturacaoDia)}
                        </h3>
                      </div>                      

                      <small className="d-flex align-items-center text-gray-500">
                        &nbsp;
                      </small>

                      <div className="d-flex justify-content-between">
                      <div className="small d-flex mt-1">
                        {/*<h2 className="h6 text-gray-400 mb-0">Entradas:</h2>*/}
                        Débito:&nbsp;
                        <span className = "text-success fw-bolder">
                          {/*<h6>{" "}{caixa.length > 0 && euro.format(caixaDiaEntradas)}</h6>*/}
                          {euro.format(faturacaoDiaDebito)}
                        </span>
                      </div>
                      <div className="small d-flex mt-1">
                        Crédito:&nbsp;
                        <span className = "text-danger fw-bolder">
                          {euro.format(faturacaoDiaCredito)}
                        </span>
                      </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-xl-4 mt-2">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="row d-block d-xl-flex align-items-center">
                    <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                      <div className="icon-shape icon-shape-secondary rounded me-4 me-sm-0">
                        <svg
                          className="icon"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </div>
                      <div className="d-sm-none">
                        <h4 className="fw-extrabold h5">Faturação do mês</h4>
                        <h3 className="mb-1">
                          {caixa.length > 0 && euro.format(caixa[0].valor)}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-xl-7 px-xl-0">
                      <div className="d-none d-sm-block">
                        <h2 className="h6 text-gray-400 mb-0">Faturação do mês</h2>
                        <h3 className="fw-extrabold mb-2">
                          {caixa.length > 0 && euro.format(caixa[0].valor)}
                        </h3>
                      </div>
                      <small className="d-flex align-items-center text-gray-500">
                        {moment().format("MMM 01")} -{" "}
                        {moment().format("MMM DD")},
                      </small>
                      <div className="d-flex justify-content-between">
                      <div className="small d-flex mt-1">
                        <div>
                          M. anterior{" "}
                          <span
                            className={
                              caixa.length > 0 && valor_mes_anterior > 0
                                ? "text-success fw-bolder"
                                : valor_mes_anterior < 0
                                ? "text-danger fw-bolder"
                                : "fw-bolder"
                            }
                          >
                            {caixa.length > 0 && valor_mes_anterior > 0
                              ? positivo
                              : valor_mes_anterior < 0
                              ? negativo
                              : ""}
                            {Math.abs(valor_mes_anterior)} %
                          </span>
                        </div>
                      </div>
                      <div className="small d-flex mt-1">
                        <div>
                          M. homólogo{" "}
                          <span
                            className={
                              caixa.length > 0 && valor_mes_homologo > 0
                                ? "text-success fw-bolder"
                                : valor_mes_homologo < 0
                                ? "text-danger fw-bolder"
                                : "fw-bolder"
                            }
                          >
                            {caixa.length > 0 && valor_mes_homologo > 0
                              ? positivo
                              : valor_mes_homologo < 0
                              ? negativo
                              : ""}
                            {Math.abs(valor_mes_homologo)} %
                          </span>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="row">

            <div className="col-12 col-sm-6 col-xl-3 mt-2">
              <div className="card card-body border-0 shadow">
                <h5>{`Entradas do dia: ${euro.format(caixaDiaEntradas)}`}</h5>
                {infoGraficoModalidadesReceitasDia.series.length > 0 && (
                  <Grafico
                    type="donut"
                    options={infoGraficoModalidadesReceitasDia.options}
                    series={infoGraficoModalidadesReceitasDia.series}
                  />
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 col-xl-3 mt-2">
              <div className="card card-body border-0 shadow">
                <h5>{`Saídas do dia: ${euro.format(caixaDiaSaidas)}`}</h5>
                {infoGraficoModalidadesSaidasDia.series.length > 0 && (
                  <Grafico
                    type="donut"
                    options={infoGraficoModalidadesSaidasDia.options}
                    series={infoGraficoModalidadesSaidasDia.series}
                  />
                )}
              </div>
            </div>

            <div className="col-12 col-sm-6 col-xl-3 mt-2">
              <div className="card card-body border-0 shadow">
                <h5>{`Entradas do mês: ${euro.format(valor_receita_mes_atual)}`}</h5>
                {infoGraficoModalidadesReceitas.series.length > 0 && (
                  <Grafico
                    type="donut"
                    options={infoGraficoModalidadesReceitas.options}
                    series={infoGraficoModalidadesReceitas.series}
                  />
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 col-xl-3 mt-2">
              <div className="card card-body border-0 shadow">
                <h5>{`Saídas do mês: ${euro.format(valor_saidas_mes_atual)}`}</h5>
                {infoGraficoModalidadesSaidas.series.length > 0 && (
                  <Grafico
                    type="donut"
                    options={infoGraficoModalidadesSaidas.options}
                    series={infoGraficoModalidadesSaidas.series}
                  />
                )}
              </div>
            </div>

          </div>

          {/* 
          <div className="row">
            <div className="col-12">
              <div className="card card-body border-0 shadow mt-2">
                <h4>{`Faturação anual: ${euro.format(valor_total_ano_corrente)}`}</h4>
                {infoGraficoCaixaAnual.series.length > 0 && (
                  <Grafico
                    type="line"
                    options={infoGraficoCaixaAnual.options}
                    series={infoGraficoCaixaAnual.series}
                    serie="Entradas"
                  />
                )}
              </div>
            </div>
          </div>
          */}

        </>
        )}


        {isLoadingCaixaAnual ? (
          <Loader />
        ) : (
          <div className="row">
            <div className="col-12">
              <div className="card card-body border-0 shadow mt-2">
                <h4>{`Faturação anual: ${euro.format(
                  valor_total_ano_corrente
                )}`}</h4>
                {infoGraficoCaixaAnual.series.length > 0 && (
                  <Grafico
                    type="line"
                    options={infoGraficoCaixaAnual.options}
                    series={infoGraficoCaixaAnual.series}
                    serie="Entradas"
                  />
                )}
              </div>
            </div>
          </div>
        )}


      </main>
    </>
  );
}

export default Financeiro;
